import { render, staticRenderFns } from "./KlarnaRegistrationPage.vue?vue&type=template&id=677e5902"
import script from "./KlarnaRegistrationPage.vue?vue&type=script&lang=js"
export * from "./KlarnaRegistrationPage.vue?vue&type=script&lang=js"
import style0 from "./KlarnaRegistrationPage.vue?vue&type=style&index=0&id=677e5902&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports